var map = {
	"./0/1.png": "b560",
	"./0/2.png": "8d2f",
	"./0/3.png": "1858",
	"./0/4.png": "64f6",
	"./0/5.png": "9ff3",
	"./0/6.png": "a7bb",
	"./0/7.png": "1f37",
	"./0/8.png": "741b",
	"./1/1.png": "4bc6",
	"./1/2.png": "ba21",
	"./1/3.png": "e980",
	"./1/4.png": "069d",
	"./1/5.png": "2e8b",
	"./1/6.png": "22fe",
	"./1/7.png": "bdef",
	"./1/8.png": "3d6d",
	"./2/1.png": "db56",
	"./2/2.png": "ce02",
	"./2/3.png": "a662",
	"./2/4.png": "ba23",
	"./2/5.png": "fc04",
	"./2/6.png": "25cf",
	"./2/7.png": "0868",
	"./2/8.png": "5506",
	"./3/1.png": "31db",
	"./3/2.png": "ed4d",
	"./3/3.png": "7e15",
	"./3/4.png": "b435",
	"./3/5.png": "056f",
	"./3/6.png": "5954",
	"./3/7.png": "65f3",
	"./3/8.png": "4628",
	"./4/1.png": "30b1",
	"./4/2.png": "4a07",
	"./4/3.png": "8010",
	"./4/4.png": "6b60",
	"./4/5.png": "f7db",
	"./4/6.png": "c20d",
	"./4/7.png": "d217",
	"./4/8.png": "4223",
	"./5/1.png": "5497",
	"./5/2.png": "79b7",
	"./5/3.png": "c8c9",
	"./5/4.png": "d0be",
	"./5/5.png": "777c",
	"./5/6.png": "aed6",
	"./5/7.png": "e414",
	"./5/8.png": "efdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71fc";